export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "harvested_batches_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registro de lotes"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])}
        }
      },
      "en": {
        "labels": {
          "harvested_batches_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Harvested batches"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to process list"])}
        }
      }
    }
  })
}